export default __webpack_public_path__ + "static/media/ticket-icon-pink.2c87107c.svg";